<template>
  <v-container class="top-spacer">
    <div class="component-title">Tiro Certeiro</div>
    <v-row>
      <v-col cols="12">
        <v-row justify="end">
          <v-dialog
            v-model="dialog"
            max-width="500px"
            content-class="backoffice-dialog"
          >
            <!-- Dialog Button -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                height="40"
                style="margin-right: 12px; top: 40px;"
                v-bind="attrs"
                v-on="on"
                @click="
                  editedItem = $lodash.cloneDeep(emptyItem);
                  dialogTitle = 'Adicionar tiro certeiro';
                "
                >Adicionar tiro certeiro
              </v-btn>
            </template>
            <v-card>
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="dialog = false"
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row>
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">{{ dialogTitle }}</div>
                  <!-- Date & Time -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Data inicio</div>
                      <DatePicker
                        :date="editedItem.startDate"
                        @dateSelected="updateStartDate"
                      ></DatePicker>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Data fim</div>
                      <DatePicker
                        :date="editedItem.endDate"
                        @dateSelected="updateEndDate"
                      ></DatePicker>
                    </v-col>
                  </v-row>
                  <!-- Sport & Country -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Prémio</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.prize"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Competition -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Descrição</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.description"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="saveItem()"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row>
          <v-col v-if="currentId > 0">
            <div class="card-label">A decorrer</div>
            <BackofficeTiroCerteiroCard
              v-if="current"
              :tiroCerteiro="current"
              @edit="editItem(current)"
              @delete="deleteItem(current)"
              @show-ranking="showRanking(current.id)"
              :key="'current-' + currentId"
            ></BackofficeTiroCerteiroCard>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="nextId > 0">
            <div class="card-label">Próximo</div>
            <BackofficeTiroCerteiroCard
              v-for="(item, index) in next"
              :key="'next-' + index"
              :tiroCerteiro="item"
              @edit="editItem(item)"
              @delete="deleteItem(item)"
              @show-ranking="showRanking(item.id)"
            ></BackofficeTiroCerteiroCard>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="previousId > 0">
            <div class="card-label">Anteriores</div>
            <BackofficeTiroCerteiroCard
              v-for="(item, index) in previous"
              :key="'prevous-' + index"
              :tiroCerteiro="item"
              @edit="editItem(item)"
              @delete="deleteItem(item)"
              @show-ranking="showRanking(item.id)"
            ></BackofficeTiroCerteiroCard>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="rankingDialog"
      content-class="backoffice-dialog"
    >
      <v-card>
        <!-- Close X button -->
        <v-toolbar flat color="#EBEFF3">
          <v-btn
            icon
            @click="rankingDialog = false"
            class="close-btn"
            color="#9AABB8"
            height="40"
            width="40"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Input text fields -->
        <v-row>
          <v-col cols="12" class="dialog-frame">
            <div class="dialog-title">Resultados Tiro Certeiro</div>
            <!-- Date & Time -->
            <v-row>
              <v-col>
                <TiroCerteiroTable :tableData="tiroCerteiroTable"></TiroCerteiroTable>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.statistics-row .col,
.tiro-certeiro-row .col {
  padding: 4px 12px 0 12px;
}
.statistics-row .black-value {
  font-size: 48px;
  line-height: 48px;
}
.dashboard-col {
  flex: 0 0 50%;
  max-width: 50%;
}
@media only screen and (max-width: 1024px) {
  .dashboard-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .top-spacer {
    padding-top: 64px !important;
  }
}
</style>

<script>
import DatePicker from "@/components/DatePicker";
import BackofficeTiroCerteiroCard from "@/components/backoffice/BackofficeTiroCerteiroCard.vue";
import TiroCerteiroTable from "@/components/TiroCerteiroTable.vue";

import ApiService from "@/services/api.service";

export default {
  name: "BackofficeTiroCerteiro",
  components: {
    DatePicker,
    BackofficeTiroCerteiroCard,
    TiroCerteiroTable
  },
  data: () => ({
    loading: false,
    dialog: false,
    rankingDialog: false,
    tiroCerteiroTable: {},
    dialogTitle: "",
    editedItem: {
      id: "",
      startDate: "",
      endDate: "",
      prize: "",
      description: ""
    },
    emptyItem: {
      id: "",
      startDate: "",
      endDate: "",
      prize: "",
      description: ""
    },
    current: {},
    currentId: 0,
    next: [],
    nextId: 0,
    previous: [],
    previousId: 0
  }),
  created() {
    this.getTirosCerteiros();
  },
  methods: {
    getTirosCerteiros() {
      ApiService.getGraphQLTirosCerteiros().then(
        response => {
          const data = response.data.data;
          this.current = data.getCurrentTiroCerteiro;
          this.currentId += 1;
          this.next = data.getNextTiroCerteiro;
          this.nextId += 1;
          this.previous = data.getPreviousTiroCerteiro;
          this.previousId += 1;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    saveItem() {
      this.loading = true;
      ApiService.saveTiroCerteiro(this.editedItem).then(
        response => {
          this.dialog = false;
          this.loading = false;
          this.getTirosCerteiros();
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    editItem(item) {
      this.dialogTitle = "Editar tiro certeiro";
      this.editedItem = this.$lodash.cloneDeep(item);
      this.editedItem.startDate = this.$moment(
        this.$lodash.cloneDeep(item.startDate),
        "x"
      ).format("YYYY-MM-DD");
      this.editedItem.endDate = this.$moment(
        this.$lodash.cloneDeep(item.endDate),
        "x"
      ).format("YYYY-MM-DD");
      this.dialog = true;
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deleteTiroCerteiro(item.id).then(
        response => {
          this.loading = false;
          this.getTirosCerteiros();
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    updateStartDate(date) {
      this.editedItem.startDate = date;
    },
    updateEndDate(date) {
      this.editedItem.endDate = date;
    },
    showRanking(id){
      ApiService.getGraphQLCerteiroRankingById(id).then(
        response => {
          const data = response.data.data;
          this.tiroCerteiroTable = this.$lodash.cloneDeep(data.getTiroCerteiroRankingById);
          this.rankingDialog = true;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  }
};
</script>
